import { memo, useState } from 'react';

import DetailPanelHeader from '@/components/detailPanel/header/DetailPanelHeader';
import Samenstelling from '@/components/detailPanel/samenstelling/Samenstelling';
import { useDetailPanel } from '@/components/detailPanel/useDetailPanel';
import CollapsibleContainer from '@/components/UI/Collapsible/CollapsibleContainer';
import { SwitchComponent } from '@/components/UI/Switch/Switch';

import TrainTimeline from './timeLine/TrainTimeLine';
import { mapInzetPositieToShortString } from './utils/utils';

import styles from './DetailPanel.module.css';

const DetailPanelHeaderMemo = memo(DetailPanelHeader);
const SamenstellingMemo = memo(Samenstelling);
const TrainTimelineMemo = memo(TrainTimeline);

export default function DetailPanel() {
  const [showAllStops, setShowAllStops] = useState(false);
  const [openRoute, setOpenRoute] = useState(true);
  const {
    selectedWerklijn,
    selectDeeltraject,
    mwdDeeltraject,
    hideDetailPanel,
    detailPanelData,
    volgendeInzetOptionsWithFlag,
    activiteitenOptions,
    handleInzetClick,
  } = useDetailPanel();

  return (
    <div className={styles.detailPanelContainer}>
      <DetailPanelHeaderMemo
        werklijn={selectedWerklijn}
        selectDeeltraject={selectDeeltraject}
        hideDetailPanel={hideDetailPanel}
        mwdDeeltraject={mwdDeeltraject}
        detailPanelData={detailPanelData}
      />
      <div className={styles.detailPanelContentContainer}>
        <SamenstellingMemo
          handleInzetClick={handleInzetClick}
          inzetId={detailPanelData?.inzetId}
          eenheid={mwdDeeltraject?.eenheid}
          geaccepteerdConflict={mwdDeeltraject?.geaccepteerdConflict}
          geplandeTreinSamenstelling={detailPanelData?.geplandeTreinSamenstelling}
          samenstelling={detailPanelData?.treinSamenstelling?.samenstelling}
          aantalZitplaatsen={detailPanelData?.treinSamenstelling?.aantalZitplaatsen}
          treinnummer={mwdDeeltraject?.treinnummer}
          inzetPositie={mwdDeeltraject?.inzetPositie}
          gekoppeldeInzetten={detailPanelData?.gekoppeldeInzetten}
        />

        <CollapsibleContainer title='Route' open={openRoute} onOpenChange={setOpenRoute}>
          {openRoute && (
            <div className={styles.switchContainer}>
              Toon alle stops
              <SwitchComponent thinVariant defaultValue={showAllStops} onChange={setShowAllStops} />
            </div>
          )}
          <TrainTimelineMemo
            inzetIsManco={mwdDeeltraject?.eenheid?.nummer === 'MANCO'}
            inzetId={detailPanelData?.inzetId}
            zitPlaatsen={detailPanelData?.treinSamenstelling?.aantalZitplaatsen}
            comfortabelNorm={detailPanelData?.treinSamenstelling?.comfortabelNorm}
            acceptabelNorm={detailPanelData?.treinSamenstelling?.acceptabelNorm}
            volNorm={detailPanelData?.treinSamenstelling?.volNorm}
            gekoppeldeInzetten={detailPanelData?.gekoppeldeInzetten || []}
            locatie={detailPanelData?.route?.laatstGemetenLocatie?.tijd}
            stations={activiteitenOptions}
            showAllStops={showAllStops}
          />

          {volgendeInzetOptionsWithFlag?.filter(({ isVolgendeInzetZelfdeRit }) => isVolgendeInzetZelfdeRit).length >
            0 && (
            <>
              <h4 style={{ fontSize: '14px', marginBottom: 0, paddingLeft: 8 }}>Volgende inzetten zelfde rit</h4>
              {volgendeInzetOptionsWithFlag
                ?.filter(({ isVolgendeInzetZelfdeRit }) => isVolgendeInzetZelfdeRit)
                .map((inzet) => (
                  <div key={`volgende-inzet-${inzet.eenheid.nummer}`}>
                    <div>
                      <div onClick={() => handleInzetClick(inzet.inzetId)} className={styles.volgendeInzetTreinInfo}>
                        <span className={styles.volgendeInzetEenheidNummer}>
                          {mwdDeeltraject?.treinnummer}
                          {mapInzetPositieToShortString(inzet.inzetPositie)}
                        </span>
                      </div>
                    </div>
                    <TrainTimelineMemo
                      inzetIsManco={mwdDeeltraject?.eenheid.nummer === 'MANCO'}
                      inzetId={inzet.inzetId}
                      zitPlaatsen={inzet.treinSamenstelling?.aantalZitplaatsen}
                      comfortabelNorm={inzet.treinSamenstelling?.comfortabelNorm}
                      acceptabelNorm={inzet.treinSamenstelling?.acceptabelNorm}
                      volNorm={inzet.treinSamenstelling?.volNorm}
                      gekoppeldeInzetten={[]}
                      locatie={undefined}
                      stations={inzet.activiteiten}
                      toonToggle={false}
                      showAllStops={false}
                      showDetails={false}
                    />
                  </div>
                ))}
            </>
          )}
        </CollapsibleContainer>
      </div>
    </div>
  );
}
